<template>
  <div class='CopyShare'>
      <el-dialog title="分享" :visible.sync="copyShareStatus" class="share-popu" width="305px" :before-close="closeDialog">
            <div class="content">
                <!-- <p class="title">华扬资本董秘培训专场社群团购优惠 {{shareeventurl}}</p> -->
                <div class="img">
                    <img :src="imgurl" alt="qrcode">
                </div>
                <!-- <p class="down" >下载二维码</p> -->
                <p style="color:#333;margin: 5px 0 10px 0">微信扫描二维码签到</p>
                <p>下载二维码可用于线下扫码签到</p>
                <el-button @click="download(imgurl, '二维码')">下载</el-button>
                <!-- <div class="btn-operate">
                    <el-input v-model="shareeventurl" class="condition" disabled></el-input>
                    <el-button  type="primary" size="mini" v-clipboard:copy="shareeventurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </div> -->
            </div>
        </el-dialog>
    <!-- end 分享弹窗 -->
  </div>
</template>

<script>
import { downloadImage, urlToQRCode} from 'common/js/tools'
export default {
    name: 'CopyShare',
    props: ['copyShareStatus','shareeventurl','imgurl'],
    data() {
        return {
            copyShareStatus: '',
            shareeventurl: '',
            imgurl: ''
        }
    },
    mounted() {
    },
    methods: {
          onCopy(e){ // 复制成功
                this.$message({
                    message: '复制成功',
                    type: 'success'
                })
            },
            onError(e) {  // 复制失败
                this.$message({
                    message: '复制失败',
                    type: 'error'
                })
            },
            download(imgsrc, name) { // 下载图片地址和图片名
                downloadImage(imgsrc, name)
            },
            closeDialog() {
                this.$emit('closeCopyShareStatus',false)
            }
    }
}
</script>

<style lang='scss' type='text/scss'>
    .CopyShare {
        .share-popu {
            .content {
                text-align: center;
                .title {
                    margin-top: 15px;
                    font-size: 14px;
                    color: #303133;
                }
                .img {
                    display: block;
                    margin: auto;
                    margin-top: 15px;
                    width:153px;
                    height:153px;
                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                        background: #ccc;
                    }
                }
                p {
                    text-align: center;
                    color: #999;
                }
                .el-button {
                    margin: auto;
                    text-align: center;
                    margin-top: 33px;
                }
                .down {
                    margin-top: 15px;
                    font-size: 14px;
                    color: #409EFF;
                }
                .btn-operate {
                    display: flex;
                    flex-wrap: nowrap;
                    -ms-flex-wrap: nowrap;
                    margin-top: 30px;
                    width: 264px;

                    .el-input input {
                        width: 210px;
                        font-size: 14px;
                        color: #c0c4cc
                    }
                    .el-button {
                        min-width: 54px;
                    }
                }
            }

        }
    }
</style>